import { Switch as MuiSwitch, styled } from '@mui/material';
import { AppointmentStatus } from 'apps/wrapper/src/services/appointment/types';

export const Container = styled('div')({
  margin: '20px 0',
  '& .carrier-name': {
    display: 'none'
  },
  '& .status-wrapper a': {
    textDecoration: 'underline'
  }
});

export const Switch = styled(MuiSwitch)({
  // checked: #008a06
  // not checked: #FFF0CA
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#008a06'
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#008a06'
  },

  '& .MuiSwitch-switchBase': {
    color: '#FFF0CA'
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#D59900'
  }
});

export const SpentChip = styled('span')({
  display: 'inline-block',
  '& .spent-chip': {
    paddingTop: 2,
    paddingBottom: 2
  }
});

export const ClickableDescription = styled('span')({
  cursor: 'pointer',
  color: '#0675DD'
});

export const StatusText = styled((props: any) => (
  <span style={{ color: props?.status == AppointmentStatus.Cancelled ? 'rgb(226, 86, 80)' : 'inherit' }}>
    {props.text}
  </span>
))(() => ({}));
